import React from 'react'
import dayjs from 'dayjs'

export interface AuditMetadata {
  createdAt: string
  createdByEmail: string | null
  updatedAt: string
  updatedByEmail: string | null
}

function formatTimestamp(iso: string) {
  const ts = dayjs(iso)
  return ts.isValid() ? ts.format('MMM D, YYYY h:mm A') : iso
}

interface Props {
  metadata: AuditMetadata
}

export default function OverrideAuditStrip({ metadata }: Props) {
  return (
    <div className="auditStrip">
      <span className="auditItem">
        <span className="auditLabel">Created</span>
        <span className="auditValue">
          {formatTimestamp(metadata.createdAt)} by{' '}
          {metadata.createdByEmail ?? '—'}
        </span>
      </span>
      <span className="auditDivider" aria-hidden>
        ·
      </span>
      <span className="auditItem">
        <span className="auditLabel">Last updated</span>
        <span className="auditValue">
          {formatTimestamp(metadata.updatedAt)} by{' '}
          {metadata.updatedByEmail ?? '—'}
        </span>
      </span>
    </div>
  )
}
